import { defineComponent as _defineComponent } from 'vue';
import { storeToRefs } from 'pinia';
import { defineComponent } from 'vue';
import StatusDowngradeTimer from '@/shared/ui/loyalty/StatusDowngradeTimer.vue';
import { useAuthStore } from '@/store/authStore';
export default /*#__PURE__*/_defineComponent({
  __name: 'DowngradeLoyaltyStatus',
  setup: function setup(__props) {
    defineComponent({
      name: 'DowngradeLoyaltyStatus'
    });
    var authStore = useAuthStore();
    var _storeToRefs = storeToRefs(authStore),
      user = _storeToRefs.user,
      isShowLoyaltyDayDowngradeStatus = _storeToRefs.isShowLoyaltyDayDowngradeStatus;
    return {
      __sfc: true,
      authStore: authStore,
      user: user,
      isShowLoyaltyDayDowngradeStatus: isShowLoyaltyDayDowngradeStatus,
      StatusDowngradeTimer: StatusDowngradeTimer
    };
  }
});